// ─────────────────────────────────────────────────────────────────────────────
// PRIORIDADE DO TICKET — o campo `prioridade` do MySuite.
//
// Entrou na API em 22/10/2026 e vem em todas as leituras de fila que o Orion
// usa (`/tickets/filasuporte`, a fila de pendentes, `/tickets/filtro` e o
// detalhe `/tickets/{n}`):
//
//   3 · Alta   — vermelho
//   2 · Média  — amarelo/laranja
//   1 · Baixa  — verde
//
// A ORDEM DAS FILAS É: prioridade (3, 2, 1) e, dentro da mesma prioridade, a
// previsão (data e hora) mais próxima primeiro. Quem decide a previsão é quem
// ordena — este módulo só responde o nível, para que a regra de prioridade seja
// uma só em todas as telas.
//
// Sem importar nada, de propósito: services/painelGerencia.js roda sob `node`
// nos testes e importa este arquivo.
// ─────────────────────────────────────────────────────────────────────────────

export const PRIORIDADES = {
  3: { rotulo: 'Alta', classe: 'prio-alta' },
  2: { rotulo: 'Média', classe: 'prio-media' },
  1: { rotulo: 'Baixa', classe: 'prio-baixa' },
};

/** 1, 2 ou 3 — ou `null` quando o ticket não traz prioridade válida. */
export function prioridadeDoTicket(ticket) {
  const p = Number(ticket?.prioridade);
  return PRIORIDADES[p] ? p : null;
}

/** `{ nivel, rotulo, classe }` da prioridade, ou `null`. */
export function infoPrioridade(ticket) {
  const nivel = prioridadeDoTicket(ticket);
  return nivel ? { nivel, ...PRIORIDADES[nivel] } : null;
}

/**
 * Comparador só do nível: a prioridade mais alta primeiro. Ticket sem
 * prioridade fica DEPOIS da baixa — sem o dado, não se promove ninguém.
 * Empate devolve 0, e quem chama desempata pela previsão.
 */
export function compararPrioridade(a, b) {
  return (prioridadeDoTicket(b) || 0) - (prioridadeDoTicket(a) || 0);
}
